export class DashboardModel {
  toBrouillon: number;
  toMyBrouillon: number;
  toWaitValidation: number;
  toMyWaitValidation: number;
  toRefuse: number;
  toMyRefuse: number;
  toValide: number;
  toMyValide: number;
  toValideRecent: number;
  toMyValideRecent: number;
  toAReceptionner: number; 
  toMyAReceptionner: number; 
  toRecent: number;
  toWaitValidationByMe: number;
  toBloque: number;
  toNonPayee: number;
  toLitige: number;
  toMyLitige: number;
}

